import { render, staticRenderFns } from "./HelpdeskSearch.vue?vue&type=template&id=6dd2aac7"
import script from "./HelpdeskSearch.vue?vue&type=script&lang=ts"
export * from "./HelpdeskSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports